import React, { createRef, useState } from "react"
import { useTranslation } from "react-i18next"

import Image from "@atoms/Image/Image"
import ModalWindow from "@atoms/ModalWindow/ModalWindow"
import "@lang/i18n"

import styles from "./ImageZoomable.module.scss"

const ImageZoomable = ({ image, widths }) => {
  const { t } = useTranslation()
  const link = createRef()

  // Why proxylink?
  // "It's not disastrous in terms of comprehension, but verbose..."
  // (https://inclusive-components.design/cards/)

  const proxyLink = () => {
    if (link.current) {
      link.current.click()
    }
  }

  const [imageModalOpen, setImageModalOpen] = useState(false)

  return (
    image && (
      <section className={styles.element}>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/no-static-element-interactions */}
        <div onClick={proxyLink}>
          <Image image={image} widths={widths} />
          <button onClick={() => setImageModalOpen(true)} ref={link}>
            <img src={"/media/svg/zoom.svg"} alt={t("Zoom")} />
          </button>
        </div>
        <ModalWindow
          open={imageModalOpen}
          setOpen={setImageModalOpen}
          label={image.alt}
          modalStyle={{ width: "144rem" }}
          margins={false}
        >
          <Image image={image} widths={[1440]} dominantColorEnabled={false} />
        </ModalWindow>
      </section>
    )
  )
}

export default ImageZoomable
